import styled from "styled-components";

export const IconDownSwicher = styled.svg`
  width: 16px;
  height: 16px;
  margin-left: 3px;
  fill: ${({ theme }) => theme?.colors?.PrivateSwicherLangsIcons};

  @media (min-width: 744px) {
    width: 24px;
    height: 24px;
  }

  @media (min-width: 1041px) {
    width: 30px;
    height: 30px;
    margin-left: 15px;
  }
`;

export const IconUpSwicher = styled.svg`
  width: 16px;
  height: 16px;
  margin-left: 3px;
  fill: ${({ theme }) => theme?.colors?.PrivateSwicherLangsIcons};

  @media (min-width: 744px) {
    width: 24px;
    height: 24px;
  }

  @media (min-width: 1041px) {
    width: 30px;
    height: 30px;
    margin-left: 15px;
  }
`;
